export default __webpack_public_path__ + "static/media/cabourg21.dee972a9.jpg";